import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Papa from "papaparse";
import { getTemplateSnapshotNames } from "../../s3/GetTemplateSnapshotNames";
import { useRepoSelected } from "../../../components/context/RepoContext";
import { fetchSnapshotCSV } from "../../s3/FetchSnapshotData";
import { formatCSVData, retrieveData } from "../../csv/JSONtoCSV";
import { CreateNewCSV } from "../../csv/CreateNewCSV";
import Modal from "../../common/Modal/Modal";
import "../../common/Modal/modal.css";
import "./newsnapshot.css";
import { generateNameIfNoInputtedName } from "./GenerateFileName";

/**
 * Creates a new snapshot from a template in the bucket's path Forms/Templates
 * and stores it in the Forms/Snapshots path.
 */

export default function NewSnapshot() {
  const [openModal, setOpenModal] = useState(false);
  const [inputtedFileName, setInputtedFileName] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [snapshots, setSnapshots] = useState([]);
  const { repoSelected } = useRepoSelected();
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);
  const [newValue, setNewValue] = useState("");
  var newName = "";
  var fileName = `${newValue}`;

  useEffect(() => {
    getS3().then(setS3);
  }, []);

  const navigate = useNavigate();

  // Modal Handling Functions
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    if (isSuccess === true) {
      setOpenModal(false);
    } else setIsError(false);
    setIsSuccess(false);
    setOpenModal(false);
  };

  // Input Handling
  const handleInputChange = (event) => {
    setInputtedFileName(event.target.value);
    setIsError(false); // Clear the error message when input changes
  };

  //Get Snapshots from AWS when modal opens
  useEffect(() => {
    if (!S3) return;
    const fetchSnapshots = async () => {
      try {
        const fetchedSnapshots = await getTemplateSnapshotNames(S3);
        setSnapshots(fetchedSnapshots);
      } catch (error) {
        console.error("Failed to fetch snapshots:", error);
      }
    };
    if (openModal) fetchSnapshots();
  }, [S3, openModal]);

  const selectValue = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue !== "Select") {
      let filename = selectedValue.split(".csv");
      setNewValue(filename[0]);
      localStorage.setItem("selectedSnapshot", filename[0]);
      setIsError(false);
      setErrorMessage("");
    }
  };

  //Get Template Snapshot Data
  // Handle double-click on a row
  const getSnapshotData = async (selectedFileName, directoryName) => {
    await fetchSnapshotCSV(S3, selectedFileName, directoryName); // Fetch data using the new function
  };

  // Create New Snapshot from Template
  const handleCreate = async () => {
    if (!newValue) {
      setIsError(true);
      setErrorMessage("A snapshot template must be selected.");
      return;
    }

    try {
      //reset errors
      setIsError(false);
      setErrorMessage("");
      //Get snapshot Data from Template
      await getSnapshotData(fileName, "Templates");

      const generatedNewName = generateNameIfNoInputtedName(fileName, inputtedFileName, setInputtedFileName, true);
      console.log("Generated new name: ", generatedNewName);
      localStorage.setItem("selectedSnapshot", generatedNewName);

      // Create the CSV string when csvData changes
      const csvData = await retrieveData();
      console.log("csvData: ", csvData);
      const formattedCSVData = formatCSVData(csvData);
      console.log("formattedCSVData: ", formattedCSVData);
      const csvString = Papa.unparse(formattedCSVData);
      console.log("csvString: ", csvString);
      const submittedFileName = await CreateNewCSV(
        S3,
        generatedNewName,
        csvString
      );

      //Store the File Data in localstorage
      await getSnapshotData(submittedFileName, "Snapshots");

      setIsSuccess(true);
      navigate(`/inputform/${submittedFileName}`);
    } catch (error) {
      setIsError(true);
      if (error.message === "UploadError") {
        setErrorMessage(
          "There was an error during the upload of the report. Please try again later."
        );
      } else if (error.message === "Duplicate Error") {
        setErrorMessage(
          "A snapshot with the same name already exists. Please try another name."
        );
      } else {
        console.error(error.message);
      }
    }
  };

  return (
    <>
      {/* Save button on Input Form Page */}
      <button
        className="newsnapshot-button"
        onClick={handleOpenModal}
        disabled={!repoSelected}
      >
        New Snapshot
      </button>
      <Modal
        isOpen={openModal}
        onClose={handleCloseModal}
        title={"New Snapshot"}
        showCustomContent={true}
        customContent={
          // Default state -> No success & no error
          <>
            <div className="newsnap-modal-description">
              Select a template and name for your new snapshot.
            </div>
            <div className="newsnap-container">
              <div className="newsnap-options-container">
                <select
                  className="settings-select"
                  onChange={selectValue}
                  defaultValue=""
                >
                  <option value="">Select a snapshot template...</option>
                  {snapshots.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <input
                value={inputtedFileName}
                onChange={handleInputChange}
                placeholder="Name your snapshot..."
                className="newsnap-input"
              />
            </div>
            <div className="newsnap-footer-container">
              {isError && (
                <p className="newsnap-error-message-modal">{errorMessage}</p>
              )}

              <button className="button-close" onClick={handleCreate}>
                Create
              </button>
            </div>
          </>
        }
      />
    </>
  );
}
